export default "__VITE_ASSET__Dfk8$HMd__"